import { Tab, Tabs } from "@material-ui/core";
import MaterialTable from "material-table";
import React, { useState } from "react";
import { CsvBuilder } from 'filefy';
import moment from 'moment';
import { GET_SELLERS_ORDERS } from "../../constants";
import API from "../../utils/api";
import tableIcons from "../common/Table/tableIcons";
import ordersTableConfig from "./config";
import "./OrdersByChefTable.css";
const OrdersByChefTable = ({
   sellerId,
   classes,
   url,
   isLoading = false,
   title = "",
   // data = [],
   noBorder = false,
   globalSearch = true,
   filtering = true,
}) => {
   const recordsPerPage = 10
   const tabs = [{
      key: 0,
      label: "Daily",
      name: "daily"
   }, {
      key: 1,
      label: "Weekly",
      name: "weekly"
   }, {
      key: 2,
      label: "Monthly",
      name: "monthly"
   }]

   const [selectedDurationTime, setSelectedDurationTime] = useState(0)
   const [key, setKey] = useState(0)
   const [localization, setLocale] = useState({});


   const tableConfig = () => ({
      columns: [
         {
            title: 'Title', field: 'formatted_order_date', filterAndSearch: false,
            render: rowData => {
               return <div>{selectedDurationTime === 1
                  ? <span><b>{rowData.formatted_order_date}</b> {` (${rowData.week_start_date} - ${rowData.week_end_date})`}</span>
                  : (rowData.formatted_order_date || "-")}
               </div>
            }
         },
         { title: 'Total Orders', field: 'total_orders', filterAndSearch: false },
         {
            title: 'Total Amount', field: 'total_price', filterAndSearch: false,
            render: rowData => <div>&#8377;{rowData.total_price || "-"}</div>
         },
      ],
   })


   const config = tableConfig().columns.map((configItem) => {
      return {
         ...configItem,
         sorting: configItem.filterAndSearch,
         filtering: configItem.filterAndSearch,
         filterPlaceholder: 'Search',
         searchable: configItem.filterAndSearch
      }
   });

   const ordersColumnsConfig = ordersTableConfig().columns.map((configItem) => {
      return {
         ...configItem,
         sorting: configItem.filterAndSearch,
         filtering: configItem.filterAndSearch,
         filterPlaceholder: 'Search',
         searchable: configItem.filterAndSearch
      }
   });

   const handleTabChange = (event, newValue) => {
      setSelectedDurationTime(newValue)
      setKey(key + 1)
   }

   return (
      <div>
         <h5 className={classes.heading}>Orders</h5>
         <Tabs value={selectedDurationTime}
            classes={{ root: classes.tabRoot }}
            className={{ root: classes.tabRoot }}
            onChange={handleTabChange}>
            {tabs.map((tab, tabIndex) => <Tab label={tab.label} key={tabIndex} />)}
         </Tabs>
         <MaterialTable
            style={{
               width: '100%',
               boxShadow: 'none',
               background: 'white',
               padding: '15px',
               borderRadius: noBorder ? '0px' : '5px'
            }}
            localization={localization}
            icons={tableIcons}
            columns={config || []}
            // actions={actions}
            // data={data}
            title={title}
            key={key} // for refresh and call api on refresh
            isLoading={isLoading}
            options={
               {
                  toolbar: globalSearch,
                  filtering: filtering,
                  search: true,
                  //columnsButton: false,
                  exportAllData: true,
                  // exportButton: true,
                  exportButton: {
                     csv: true,
                     pdf: false,
                  },
                  exportCsv: (columns, data) => {
                     const columnTitles = columns.map(columnDef => columnDef.title);

                     const csvExportData = []

                     data.forEach(rowData => {
                        const data = columns.map(columnDef => rowData[columnDef.field])
                        csvExportData.push(data)

                        if (rowData.total_orders) {
                           const orderColumns = [
                              '',
                              'Invoice Id',
                              'Delivery Task Id',
                              'Seller Name',
                              'Business Name',
                              'Business Address',
                              'Business Pincode',
                              'Seller Mobile',
                              'Buyer Name',
                              'Buyer Email',
                              'Buyer Address',
                              'Buyer Pincode',
                              'Order Date',
                              'Order Type',
                              'Order Amount',
                              'GST',
                              'Total Amount',
                              'Delivery Type',
                              'Payment Status',
                              'Delivery Status'
                           ]
                           const orderFileds = [
                              { name: 'invoice_id', subField: "" },
                              { name: 'delivery_task_id', subField: "" },
                              { name: 'sellerDetails', subField: "businessDetails", subField2: "business_name" },
                              { name: 'sellerDetails', subField: "businessDetails", subField2: "address_line1" },
                              { name: 'sellerDetails', subField: "businessDetails", subField2: "pin_code" },
                              { name: 'sellerDetails', subField: "mobile_no" },
                              { name: 'buyerDetails', subField: "name" },
                              { name: 'buyerDetails', subField: "email_id" },
                              { name: 'buyerDetails', subField: "address_line1" },
                              { name: 'buyerDetails', subField: "pin_code" },
                              { name: 'order_date_local', subField: "" },
                              { name: 'advance_booking', subField: "" },
                              { name: 'amount', subField: "" },
                              { name: 'tax', subField: "" },
                              { name: 'delivery_charges', subField: "" },
                              { name: 'net_amount', subField: "" },
                              { name: 'delivery_option', subField: "option_name" },
                              { name: 'payment', subField: "payment_status" },
                              { name: 'fulfillment_status', subField: "" },
                           ]

                           const ordersData = rowData.orders.map(order => {
                              const ordersDataDetails = ['']
                              const orderData = orderFileds.map((orderFiled) => {
                                 let orderValue = order[orderFiled.name]
                                 if (orderFiled.subField && orderValue) {
                                    orderValue = order[orderFiled.name][orderFiled.subField]

                                    if (orderFiled.subField2 && orderValue) {
                                       orderValue = order[orderFiled.name][orderFiled.subField][orderFiled.subField2]
                                    }
                                 }

                                 if (orderFiled.name === "order_date_local") {
                                    return moment.utc(orderValue).local().format("DD-MM-YYYY h:mm:ss a")
                                 }

                                 if (orderFiled.name === "advance_booking") {
                                    return orderValue ? "Advance Booking" : "Normal Booking"
                                 }

                                 return orderValue
                              })

                              ordersDataDetails.push(...orderData)

                              return ordersDataDetails
                           })

                           csvExportData.push(orderColumns)
                           csvExportData.push(...(ordersData || []))
                        }
                     });

                     const builder = new CsvBuilder(`chef-orders-history.csv`)
                        .setColumns(columnTitles)
                        .addRows(csvExportData);

                     builder.exportFile()

                     return builder;
                  },
                  exportFileName: "orders-history",
                  sorting: true,
                  hideFilterIcons: true,
                  actionsColumnIndex: -1,
                  tableLayout: 'fixed',
                  searchFieldAlignment: 'left',
                  pageSize: recordsPerPage,
                  paginationType: 'stepped',
                  pageSizeOptions: [],
                  headerStyle: {
                     backgroundColor: '#f58634',
                     color: 'white',
                     padding: '8px 0 8px 16px',
                     width: 50
                  },
                  filterCellStyle: {
                     backgroundColor: '#fef3ea',
                     padding: '8px 0 8px 16px',
                  },
                  searchFieldStyle: {
                     borderRadius: '20px',
                     border: '1px solid grey',
                     padding: '5px 35px',
                     marginBottom: '10px',
                     display: 'none'
                  }
               }
            }
            data={query =>
               new Promise((resolve, reject) => {
                  setLocale({ body: { emptyDataSourceMessage: '' } });
                  let filters = [];
                  const selectedTab = tabs.find(tab => tab.key === selectedDurationTime)
                  let painationProps = [
                     `recordsPerPage=${recordsPerPage}`,
                     `pageNo=${query.page + 1}`,
                     `filter=${selectedTab.name}`
                  ];

                  if (query.filters.length > 0) {
                     filters = query.filters.map(
                        filter => `${filter.column.field}=${filter.value}`
                     );
                  }
                  let apiUrl = `${GET_SELLERS_ORDERS.replace(':seller_id', sellerId)}?`;
                  apiUrl += [
                     ...filters,
                     ...painationProps
                  ].join('&');

                  API.get(apiUrl).then(response => {
                     console.log("response---------------", response);
                     const result = response.data.ResponseData || {};

                     resolve({
                        data: result.data || [],
                        page: query.page,
                        totalCount: response.data.ResponseData.totalCount || 0
                     });
                     setLocale({
                        body: {
                           emptyDataSourceMessage: isLoading
                              ? ''
                              : 'No Records found'
                        }
                     });
                  });
               })
            }
            detailPanel={rowData => {
               return (
                  <div id={"order-listing-table"} className={classes.orderTable}>
                     <div className="order-chef-table-wrapper">
                        <MaterialTable
                           style={{
                              width: '100%',
                              boxShadow: 'none',
                              background: 'white',
                              padding: '15px',
                              borderRadius: noBorder ? '0px' : '5px',
                              height: 'auto'
                           }}
                           key={rowData.id}
                           columns={ordersColumnsConfig}
                           data={rowData.orders.sort((a, b) => a.order_id - b.order_id)}
                           icons={tableIcons}
                           title={title}
                           isLoading={isLoading}
                           options={{
                              search: true,
                              toolbar: globalSearch,
                              filtering: filtering,
                              sorting: true,
                              exportAllData: true,
                              exportButton: true,
                              exportFileName: rowData.formatted_order_date + "_orders",
                              hideFilterIcons: true,
                              actionsColumnIndex: -1,
                              tableLayout: 'fixed',
                              searchFieldAlignment: 'left',
                              // paginationType: 'stepped',
                              // pageSize: rowData.orders.length,
                              // pageSizeOptions: [],
                              headerStyle: {
                                 backgroundColor: "#FEF3EA",
                                 padding: '8px 0 8px 16px'
                              },
                              filterCellStyle: {
                                 backgroundColor: '#fef3ea',
                                 padding: '8px 0 8px 16px'
                              },
                              searchFieldStyle: {
                                 borderRadius: '20px',
                                 border: '1px solid grey',
                                 padding: '5px 35px',
                                 marginBottom: '10px',
                                 display: 'none'
                              },
                              paging: false,
                              search: false,
                              maxBodyHeight: 'auto', // Automatically adjust body height
                              rowStyle: {
                                 height: "10px", // Set row height to auto
                              },
                           }} />
                     </div>
                  </div>
               )
            }}
            onRowClick={(event, rowData, togglePanel) => togglePanel()}
         />
      </div>
   )
}

export default OrdersByChefTable